// src/features/Management/page/Role

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import type { ColumnsType } from 'antd/es/table';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { RoleType } from '../../types/managementTypes';
import { useRouter } from '@tanstack/react-router';
import { Button } from 'antd';
import { FaRegEye } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';



const RolePage = () => {
    const { t } = useTranslation();
    const router = useRouter();

    // Define columns for the Role table
    const roleColumns: ColumnsType<RoleType> = [
        { title: "Name", dataIndex: "name", key: "name" },
        {
            title: 'Permissions',
            key: 'permissions',
            render: (_, record) => (
                <Button
                    icon={<FaRegEye />}
                    type="link"
                    onClick={() => {
                        router.navigate({
                            to: '/management/roles/permissions',
                            state: { id: record.id, name: record.name } as Record<string, unknown>,
                        });
                    }}
                >
                    {t("Permissions")}
                </Button>
            ),
        },
    ];

    return (
        <div>
            <DynamicTable<RoleType> // Ensure generic type matches the data
                dataApiUrl={API_ENDPOINTS.MANAGEMENT.GET_ROLES} // Your API endpoint for fetching menus
                baseQueryKey={QUERY_KEYS.MANAGEMENT.ROLES} // Unique query key for menus
                columns={roleColumns}
                tableTitle={"Role(s) Management"}
                showActions={true} // Set to true if you want Edit/Delete actions
                deleteBaseUrl={API_ENDPOINTS.MANAGEMENT.DELETE_ROLES}
                // Pass the fields you want the search bar to filter
                filterConfigs={[
                    { field: "name", placeholder: "Search by Name" },

                ]}
            />
        </div>
    );
};

export default RolePage;